import { type Components, type Theme } from "@mui/material";

export const MuiTab: Components<Theme>["MuiTab"] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 0,
      fontWeight: 600,
      textTransform: "none",
      color: theme.palette.text.secondary,
      "&:hover": {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.grey[50],
      },
      "&.Mui-selected": {
        color: theme.palette.primary.main,
        fontWeight: 700,
      },
      "&.Mui-focusVisible": {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: "2px",
      },
    }),
  },
};
